"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-3 w-20 bg-muted animate-pulse rounded-sm" />
        <div className="h-3 w-24 bg-muted animate-pulse rounded-sm" />
        <div className="h-3 w-16 bg-muted animate-pulse rounded-sm" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors duration-200">
            {item.label}
          </Link>
        </div>)}
    </nav>;
}
export default function TerminalFooter() {
  return <section id="terminal-footer" className="dark bg-background text-foreground py-16 px-6 font-mono text-xs border-t border-border/10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
        {}
        <div className="flex flex-col items-start justify-between h-full">
          <Link to="/">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/worldaccess_terminal_logo.png" alt="WorldAccess" className="h-7 opacity-90 hover:opacity-100 transition-opacity" />
          </Link>
          <div className="mt-8 md:mt-auto text-muted-foreground/60">
            © 2024
          </div>
        </div>

        {}
        <div className="flex flex-col items-start md:items-center">
          <MenuProvider menu_id="23">
            <FooterNav />
          </MenuProvider>
        </div>

        {}
        <div className="flex flex-col items-start md:items-end justify-start">
          <div className="inline-flex items-center gap-3 bg-secondary/30 px-4 py-2 rounded-sm border border-border/20 backdrop-blur-sm">
            <span className="relative flex size-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full size-2 bg-emerald-500"></span>
            </span>
            <span className="text-muted-foreground tracking-tight">
              System Status: <span className="text-foreground font-medium">Online</span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}